import moment from 'moment'

export default function (value, na='n/a') {
  if (value.length<9) value = '2020-01-31 ' + value // only time given
  return value && value !== '' ? moment(value).format('hh:mm a') : na
}
